import React, { useState } from "react";
import { Modal, Box, Typography, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import {
  handleEditPackageName,
  setMyPermitsSnackOpen,
} from "../../store/actions/uiActions/myPermitsActions";

function ChangePackageNameModal({ open, setOpen }) {
  const { changePackageNameLoading } = useSelector(
    (state) => state.myPermitsComponent.permits
  );
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);

  const dispatch = useDispatch();
  const [packageName, setPackageName] = useState(
    selectedRow?.package_name || ""
  );
  const [nameRespText, setNameRespText] = useState("");
  const [isError, setIsError] = useState(false);

  const onConfirm = async () => {
    const resp = await dispatch(handleEditPackageName(packageName));

    if (resp?.success === false) {
      setIsError(true);
      setNameRespText(resp?.message);
    } else {
      setOpen(false);
      setNameRespText("");
      dispatch(
        setMyPermitsSnackOpen({
          isOpen: true,
          snackText: "The package name has been successfully updated",
        })
      );
    }
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h4"
          align="center"
          component="h2"
          color="primary"
          mb={2}
        >
          Edit Package Name
        </Typography>

        <TextField
          error={isError}
          onChange={(e) => {
            setPackageName(e.target.value);
            setIsError(false);
          }}
          fullWidth
          label="Package Name"
          value={packageName}
        />
        <Typography>{nameRespText}</Typography>

        <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between" }}>
          <LoadingButton
            loading={changePackageNameLoading}
            sx={{ mr: 1 }}
            fullWidth
            color="error"
            onClick={() => setOpen(false)}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            loading={changePackageNameLoading}
            disabled={changePackageNameLoading || packageName === ""}
            sx={{ ml: 1 }}
            fullWidth
            variant="contained"
            color="success"
            onClick={onConfirm}
          >
            Submit
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}

export default React.memo(ChangePackageNameModal);
